var FuseSidebarModule = /** @class */ (function () {
    function FuseSidebarModule() {
    }
    return FuseSidebarModule;
}());
export { FuseSidebarModule };
